<section class="flex container">
	<app-header class="content flex"></app-header>
	@if (stepActive$ | async; as step) {
		<bci-wk-stepper-horizontal [steps]="steps" [active]="step"></bci-wk-stepper-horizontal>
		<app-loader class="content flex"></app-loader>
		<div [class.hidden]="loader$ | async">
			<router-outlet></router-outlet>
		</div>
	}
	<app-snackbar class="content flex"></app-snackbar>
	<app-survey class="content flex"></app-survey>
	<app-footer class="content flex"></app-footer>
</section>
